import { post } from './api/helper';
import { buildState, buildSuggestionsState } from './helpers/responseAdapter';
import {
  transformSearchUIStateToQuery,
  transformSuggestionUIStateToQuery,
  transformClickResultsUIStateToQuery,
} from './helpers/transformUIStateToQuery';
import { SezzleDirectoryEndpoint } from './types/enums';

export const config = {
    debug: process.env.NODE_ENV === 'production' ? false : true,
    onAutocomplete: async state => {
      // For suggested queries:
      const suggestionsResponseBody = transformSuggestionUIStateToQuery(state);
      let suggestionResults;
      let resultsResults;
      try {
      const suggestionsResponse = await post(
        SezzleDirectoryEndpoint.SuggestionURL,
        suggestionsResponseBody,
      );
      suggestionResults = buildSuggestionsState(suggestionsResponse);
      } catch (error) {
        console.error(error);
        return;
      }

      // // for suggested results:
      const query = transformSearchUIStateToQuery(state);
      try {
      const resultsResponse = await post(
        SezzleDirectoryEndpoint.SearchURL,
        query,
      );

      resultsResults = buildState(resultsResponse);
      } catch(error) {
        console.error(error);
        return;
      }

      return {
        autocompletedSuggestions: suggestionResults?.results,
        autocompletedSuggestionsRequestId: suggestionResults?.requestId,
        autocompletedResults: resultsResults?.results.slice(0, 5),
        autocompletedResultsRequestId: resultsResults?.requestId,
      };
    },
    onAutocompleteResultClick: async state => {
      await post(
        SezzleDirectoryEndpoint.ClickURL,
        transformClickResultsUIStateToQuery(state),
      );
    },
    onSearch: async state => {
      let query = transformSearchUIStateToQuery(state);
      try {
      const response = await post(SezzleDirectoryEndpoint.SearchURL, query);
      return buildState(response);
      } catch(error) {
        console.error(error);
        return;
      }
    },
};
